import { lazy, Suspense } from 'react';

import { Loading } from './loading';

const Dashboard = lazy(() => import('./dashboards'));

export function DashboardPage() {
  return (
    <Suspense fallback={<Loading />}>
      <Dashboard />
    </Suspense>
  );
}
